import { InputAdornment } from '@mui/material';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import CurrencyMask from 'components/rebrand/CurrencyMask';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import React from 'react';
import RebrandTooltip from 'components/rebrand/RebrandTooltip';

const moneyAdornment = {
  startAdornment: <InputAdornment position='start'>$</InputAdornment>
};

const monthlyIncomeLabel = (
  <>
    Gross Monthly Income <span style={{ fontWeight: 'bold' }}>Before</span>{' '}
    Taxes
  </>
);

const tooltipText =
  'Income derived from alimony, child support, or separate maintenance payments may be included, but is not required, to determine your creditworthiness.';
const toolTip = () => (
  <RebrandTooltip
    additionalStyle={{ marginTop: '0.25rem !important' }}
    text={tooltipText}
  />
);

const page6 = {
  defaultNextPage: 'page-7',
  content: [
    configureProgressBar(24),
    configureTitle(['How much do you make', 'before taxes?']),
    {
      component: BasicInput,
      props: {
        id: 'grossMonthlyIncome',
        label: monthlyIncomeLabel,
        type: 'text',
        isNumeric: true,
        adornment: moneyAdornment,
        InputProps: {
          inputComponent: CurrencyMask
        },
        TooltipComponent: toolTip
      }
    },
    nextButtonConfig('page-6')
  ]
};

export default page6;
